<template>
  <page-template>
    <template slot="page-content">
      <div class="info--template page-template page-transition">
        <!-- CONTENT -->
        <div class="relative">
          <div class="relative z-3000">
            <section
              class="relative mw12 flex flex-row z-1 z-content bg-beige"
              :id="page.faq_section.slug"
            >
              <!-- MOBILE -->
              <div
                class="bg-cream w-100 dn-ns"
                v-if="isWindowWidthMobile == true"
              >
                <div
                  class="container-fluid bg-cream relative z-4 overflow-hidden"
                >
                  <!-- FAQ -->
                  <h2
                    class="f39px pb4 pt4 black-bottom is-blenny is-navy"
                    :id="page.faq_section.slug"
                  >
                    {{ page.faq_section.title }}
                  </h2>
                </div>
                <div
                  ref="mobileFAQContainer"
                  class="relative acc-height info-bb"
                  :style="{ 'min-height': mobileMinHeight() }"
                >
                  <div
                    v-for="(faq_topic, key) in page.faq_section.faq_topics"
                    class=""
                  >
                    <!-- <div v-show="mobileActive == key" class="bg-cream-light-green-split-after mobile-acc"></div> -->
                    <accordion
                      :type="'mobile-info'"
                      :index="key"
                      :mobileActive.sync="mobileActive"
                    >
                      <template slot="parent-nav-link">
                        <!-- TOPIC -->
                        <h3 class="f26px is-tablet-bold">
                          {{ faq_topic.title }}
                        </h3>
                      </template>
                      <template slot="sub-nav-links">
                        <div class="">
                          <div
                            class="w-100 container-fluid question-answer"
                            v-for="questions in faq_topic.faqs"
                          >
                            <div class="db pv4 f4 no-underline" to="questions">
                              <accordion
                                :type="'desktop-info'"
                                :closed="true"
                                :mobileFaqAnswerExpanded="
                                  mobileFaqAnswerExpanded
                                "
                              >
                                <template slot="parent-nav-link">
                                  <!-- QUESTION -->
                                  <h4
                                    class="f3 is-tablet-bold is-navy mr3 w-100"
                                  >
                                    {{ questions.question }}
                                  </h4>
                                </template>
                                <template slot="sub-nav-links">
                                  <!-- ANSWER -->
                                  <div
                                    v-if="questions.answer_text"
                                    class="f4 is-tablet-regular lh-20px cms-content pt4"
                                    v-html="marked(questions.answer_text)"
                                  ></div>
                                </template>
                              </accordion>
                            </div>
                          </div>
                        </div>
                      </template>
                    </accordion>
                  </div>
                  <hr />
                </div>
              </div>

              <!-- DESKTOP -->
              <div
                class="dn relative flex-ns flex-grow-1"
                v-if="isWindowWidthMobile == false"
                :id="page.faq_section.slug"
              >
                <div class="mw6 w-100 pb5 pl5 minh-450">
                  <div class="h-100">
                    <div class="info-bg sticky-nav">
                      <div class="pr5">
                        <!-- FAQ -->
                        <h2
                          class="f98px mb4 is-blenny is-navy"
                          :id="page.faq_section.slug"
                        >
                          {{ page.faq_section.title }}
                        </h2>
                        <div
                          class="pv2"
                          v-for="(faq_topic, key) in page.faq_section
                            .faq_topics"
                        >
                          <accordion
                            :index="key"
                            :desktopActive.sync="desktopActive"
                          >
                            <template slot="parent-nav-link">
                              <!-- TOPIC -->
                              <h3
                                :class="{ active: desktopActive == key }"
                                class="f26px is-tablet-bold"
                              >
                                {{ faq_topic.title }}
                              </h3>
                            </template>
                          </accordion>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-100 is-black mt6 pt5">
                  <div class="pl4 pr6 mt4 mb5 z-4 relative">
                    <div
                      class="z-4 relative"
                      v-for="(faq_topic, key) in page.faq_section.faq_topics"
                    >
                      <div
                        :id="faq_topic.slug"
                        v-show="desktopActive == key"
                        class="b--is-black-50 bb"
                      >
                        <div
                          class="b--is-black-50 bb pv4"
                          v-for="(questions, key) in faq_topic.faqs"
                          :id="'faq-item-' + key"
                        >
                          <accordion :type="'desktop-info'" :closed="true">
                            <template slot="parent-nav-link">
                              <!-- QUESTION -->
                              <h4
                                class="f3 is-tablet-bold is-navy pb1 mr4"
                                :ref="questions.question"
                              >
                                {{ questions.question }}
                              </h4>
                            </template>
                            <template slot="sub-nav-links">
                              <!-- ANSWER -->
                              <div
                                v-if="questions.answer_text"
                                class="f4 is-tablet-regular pt4 lh-20px cms-content"
                                v-html="marked(questions.answer_text)"
                              ></div>
                            </template>
                          </accordion>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>

        <div class="relative bg-beige z-content" ref="participateSection">
          <div class="relative container-fluid">
            <section
              class="relative center mw8-5 pt5 pb4 pb5-ns is-black"
              :id="page.participate_section.slug"
            >
              <div class="row">
                <div class="col-xs-12 col-sm-4 ph3">
                  <img
                    class="db relative center img-responsive w-100"
                    :src="page.participate_section.content['0'].image.src_image"
                    :alt="page.participate_section.content['0'].image.alt"
                  />
                  <h3 class="f23px f38px-ns is-tablet-bold mt3 mb3 is-navy">
                    {{ page.participate_section.content["0"].title }}
                  </h3>
                  <div
                    class="f15px f18px-ns is-tablet-regular mb3 lh-copy cms-content"
                    v-html="marked(page.participate_section.content['0'].text)"
                  ></div>
                  <a
                    v-if="page.participate_section.content['0'].cta.link"
                    class="f15px is-tablet-bold"
                    :title="
                      page.participate_section.content['0'].cta.link_title
                    "
                    :href="page.participate_section.content['0'].cta.link"
                    >{{ page.participate_section.content["0"].cta.text
                    }}<simple-svg
                      class="checkout"
                      :filepath="'/uploads/checkout-arrow.svg'"
                    ></simple-svg
                  ></a>
                </div>
                <div class="col-xs-12 col-sm-4 ph3">
                  <img
                    class="db relative center img-responsive w-100 pt4 pt0-m pt0-l"
                    :src="page.participate_section.content['1'].image.src_image"
                    :alt="page.participate_section.content['1'].image.alt"
                  />
                  <h3 class="f23px f38px-ns is-tablet-bold mt3 mb3 is-navy">
                    {{ page.participate_section.content["1"].title }}
                  </h3>
                  <div
                    class="f15px f18px-ns is-tablet-regular mb3 lh-copy cms-content"
                    v-html="marked(page.participate_section.content['1'].text)"
                  ></div>
                  <a
                    v-if="page.participate_section.content['1'].cta.link_title"
                    class="f15px is-tablet-bold"
                    :title="
                      page.participate_section.content['1'].cta.link_title
                    "
                    :href="page.participate_section.content['1'].cta.link"
                    >{{ page.participate_section.content["1"].cta.text
                    }}<simple-svg
                      class="checkout"
                      :filepath="'/uploads/checkout-arrow.svg'"
                    ></simple-svg
                  ></a>
                </div>
                <div class="col-xs-12 col-sm-4 ph3">
                  <img
                    class="db relative center img-responsive w-100 pt4 pt0-m pt0-l"
                    :src="page.participate_section.content['2'].image.src_image"
                    :alt="page.participate_section.content['2'].image.alt"
                  />
                  <h3 class="f23px f38px-ns is-tablet-bold mt3 mb3 is-navy">
                    {{ page.participate_section.content["2"].title }}
                  </h3>
                  <div
                    class="f15px f18px-ns is-tablet-regular mb3 lh-copy cms-content"
                    v-html="marked(page.participate_section.content['2'].text)"
                  ></div>
                  <a
                    v-if="page.participate_section.content['2'].cta.link_title"
                    class="f15px is-tablet-bold"
                    :title="
                      page.participate_section.content['2'].cta.link_title
                    "
                    :href="page.participate_section.content['2'].cta.link"
                    >{{ page.participate_section.content["2"].cta.text
                    }}<simple-svg
                      class="checkout"
                      :filepath="'/uploads/checkout-arrow.svg'"
                    ></simple-svg
                  ></a>
                </div>
              </div>
            </section>
          </div>
        </div>

        <fixedbg class="z-1" :background="page.reveal_content_section.image">
          <template slot="contents">
            <div class="relative container-fluid">
              <section class="relative mw8 center pv5 pv6-ns">
                <div
                  class="f28px f38px-ns is-tablet-bold tl is-cream"
                  v-html="marked(page.reveal_content_section.text)"
                ></div>
                <div class="flex mt4 flex-column flex-row-ns items-center">
                  <a
                    class="btn-generic has-red-bg mr4-ns mb4 mb0-m mb0-l"
                    v-for="(item, index) in page.reveal_content_section.links"
                    v-if="item.link && item.is_published"
                    :href="item.link"
                    :title="item.title"
                    :key="'button-' + index"
                  >
                    <span class="text ttu is-lorano-reg">
                      {{ item.title }}
                    </span>
                  </a>
                </div>
              </section>
            </div>
          </template>
        </fixedbg>

        <div class="relative bg-beige z-content">
          <!-- Accessibility -->
          <div class="relative bg-beige z-content">
            <div class="relative container-fluid">
              <section
                class="relative center mw8-5 pt3 pt5-ns pb5 pv5-ns is-black"
                :id="page.accessibility_section.slug"
              >
                <h3
                  class="f98px-ns f39px is-blenny is-navy ttu mb3 mt4 mt0-m mt0-l"
                >
                  {{ page.accessibility_section.title }}
                </h3>
                <div class="row">
                  <div class="col-xs-12 col-sm-6">
                    <img
                      class="db relative center img-responsive w-100 mb3 mb0-m mb0-l"
                      :src="page.accessibility_section.image.src_image"
                      :alt="page.accessibility_section.image.alt"
                    />
                  </div>
                  <div class="col-xs-12 col-sm-6 pl5-ns">
                    <div class="flex flex-column h-100 justify-center">
                      <div>
                        <div
                          class="f15px f18px-ns is-tablet-regular mb3 lh-copy"
                          v-html="marked(page.accessibility_section.text)"
                        ></div>
                        <a
                          class="f15px f18px-ns is-tablet-regular ttu is-teal link"
                          :title="page.accessibility_section.cta.link_title"
                          :href="page.accessibility_section.cta.link"
                          >{{ page.accessibility_section.cta.text }}</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>

          <!-- Festival Map -->
          <div
            class="relative bg-beige z-content"
            v-if="page.festival_map_section.is_published"
          >
            <div class="relative container-fluid">
              <section
                class="relative center mw8-5 is-black"
                :id="page.festival_map_section.slug"
              >
                <div class="row">
                  <div class="col-xs-12 col-sm-8 col-md-10">
                    <h3 class="f98px-ns f39px is-blenny is-navy ttu pb2 pb4-ns">
                      {{ page.festival_map_section.title }}
                    </h3>
                  </div>
                  <div class="col-xs-12 col-sm-4 col-md-2 pb4 relative">
                    <!-- <div class="f15px is-tablet-regular lh-copy mb4" v-html="marked(page.festival_map_section.text)"></div> -->
                    <a
                      class="f25px-ns f20px is-tablet-bold is-navy absolute-ns bottom-4 right-1 ttu"
                      :title="page.festival_map_section.cta.link_title"
                      :href="page.festival_map_section.cta.link"
                      target="_blank"
                      >{{ page.festival_map_section.cta.text }}</a
                    >
                  </div>
                  <div class="col-xs-12 col-sm-12">
                    <img
                      class="db relative center img-responsive w-100"
                      :src="page.festival_map_section.main_map.image"
                      :alt="page.festival_map_section.title"
                    />
                  </div>
                </div>
              </section>
            </div>
          </div>

          <!-- Partners -->
          <div
            class="relative bg-beige z-content"
            :id="page.partners_section.slug"
          >
            <div class="relative container-fluid">
              <section class="relative center mw8-5 pt5 is-cream">
                <div class="row">
                  <div class="col-xs-12">
                    <h3 class="f98px-ns f39px is-blenny is-navy ttu mb3 mb4-ns">
                      {{ page.partners_section.title }}
                    </h3>
                  </div>
                  <div
                    class="col-xs-6 col-sm-4 col-md-2"
                    v-for="(partner, index) in page.partners_section.partners"
                    :key="'parnter-logos-' + index"
                    v-if="partner.is_published === true"
                  >
                    <a
                      v-if="partner.css_class"
                      class="image-zoom db relative mb3 aspect-ratio--1x1 bg-white partner-img"
                      :class="partner.css_class"
                      :href="partner.link"
                      target="_blank"
                      :title="partner.title"
                      v-lazy:background-image="partner.image"
                    ></a>
                    <a
                      v-else
                      class="image-zoom db relative mb3 aspect-ratio--1x1 bg-white partner-img"
                      :href="partner.link"
                      target="_blank"
                      :title="partner.title"
                      v-lazy:background-image="partner.image"
                    ></a>
                  </div>
                </div>
              </section>
            </div>
          </div>

          <!-- Outside Lands Works -->
          <div class="relative bg-beige z-content">
            <div class="relative container-fluid">
              <section
                class="relative center mw8-5 pt5 is-black"
                :id="page.olworks_section.slug"
              >
                <div class="row">
                  <h3
                    class="f98px-ns f39px is-blenny is-navy ttu mb3 mb4-ns mt4 mt0-m mt0-l"
                  >
                    {{ page.olworks_section.title }}
                  </h3>
                  <div class="col-xs-12 col-sm-6">
                    <img
                      class="db relative center img-responsive w-100 mb3 mb0-m mb0-l"
                      :src="page.olworks_section.image"
                    />
                  </div>
                  <div class="col-xs-12 col-sm-6 pl5-ns">
                    <div class="flex flex-column h-100 justify-center">
                      <div>
                        <div
                          class="f15px f18px-ns is-tablet-regular mb3 lh-copy"
                          v-html="marked(page.olworks_section.text)"
                        ></div>
                        <router-link
                          class="f15px f18px-ns is-tablet-regular ttu is-red link"
                          :title="page.olworks_section.cta_link.title"
                          :to="page.olworks_section.cta_link.link"
                          >{{
                            page.olworks_section.cta_link.title
                          }}</router-link
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>

          <!-- Take Action -->
          <div class="relative bg-beige z-content">
            <div class="relative container-fluid">
              <section
                class="relative center mw8-5 pt5 pb5 is-black"
                :id="page.take_action_section.slug"
              >
                <div class="row">
                  <h3
                    class="f98px-ns f39px is-blenny is-navy ttu mb3 mb4-ns mt4 mt0-m mt0-l"
                  >
                    {{ page.take_action_section.title }}
                  </h3>
                  <div class="col-xs-12 col-sm-6">
                    <img
                      class="db relative center img-responsive w-100 mb3 mb0-m mb0-l"
                      v-lazy="page.take_action_section.image"
                    />
                  </div>
                  <div class="col-xs-12 col-sm-6 pl5-ns">
                    <div class="flex flex-column h-100 justify-center">
                      <div>
                        <div
                          class="f15px f18px-ns is-tablet-regular mb3 lh-copy"
                          v-html="marked(page.take_action_section.text)"
                        ></div>
                        <router-link
                          v-if="
                            page.take_action_section.cta &&
                              page.take_action_section.cta.link
                          "
                          class="f15px f18px-ns is-tablet-regular ttu is-red link"
                          title="Take a Stand"
                          :to="page.take_action_section.cta.link"
                          >{{ page.take_action_section.cta.title }}</router-link
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>

          <!-- Attractions M -->
          <div
            class="relative bg-beige z-content"
            v-if="isWindowWidthMobile == true"
          >
            <div class="relative container-fluid">
              <h3 class="f98px-ns f39px is-blenny is-navy ttu pt4">
                {{ page.attractions_section.title }}
              </h3>
            </div>
            <section
              class="relative center pt3 pb4 is-black"
              :id="page.attractions_section.slug"
            >
              <swiper
                :options="swiperOptions"
                ref="mySwiper"
                class="container-fluid-important"
              >
                <swiper-slide
                  v-for="(item, index) in page.attractions_section.attractions"
                  :key="'park-attractions-m-' + index"
                >
                  <div class="relative container-fluid-full-width-xs">
                    <div class="db w-100">
                      <a
                        class="image-zoom2"
                        :title="item.cta.link_title"
                        :href="item.cta.link"
                      >
                        <div
                          class="relative aspect-ratio--1x1"
                          :style="{
                            background: 'url(' + item.image.src_image + ')'
                          }"
                        ></div>
                        <h3
                          class="f23px f38px-ns is-navy is-tablet-bold mt4 mb3 is-black"
                        >
                          {{ item.title }}
                        </h3>
                      </a>
                      <div
                        class="f15px f18px-ns is-tablet-regular mb3 lh-copy"
                        v-html="item.text"
                      ></div>
                      <a
                        class="f15px f18px-ns is-tablet-regular ttu is-black"
                        :title="item.cta.link_title"
                        :href="item.cta.link"
                        >{{ item.cta.text }}</a
                      >
                    </div>
                  </div>
                </swiper-slide>
              </swiper>
            </section>
          </div>
          <!-- Attractions DT-->
          <div
            class="relative bg-beige z-content"
            v-if="isWindowWidthMobile == false"
          >
            <div class="relative container-fluid">
              <section
                class="relative center mw8-5 is-black pt5"
                :id="page.attractions_section.slug"
              >
                <div class="row">
                  <div class="col-xs-12">
                    <h3 class="f98px-ns f39px is-blenny is-navy ttu mb4">
                      {{ page.attractions_section.title }}
                    </h3>
                  </div>
                  <div
                    class="col-xs-12 col-sm-4 pb5 ph3"
                    v-for="(item, index) in page.attractions_section
                      .attractions"
                    :key="'park-attractions-dt-' + index"
                  >
                    <div class="w-100">
                      <a
                        class="image-zoom2"
                        :title="item.cta.link_title"
                        :href="item.cta.link"
                      >
                        <div
                          class="relative aspect-ratio--1x1"
                          :style="{
                            background: 'url(' + item.image.src_image + ')'
                          }"
                        ></div>
                        <h3
                          class="f23px f38px-ns is-navy is-tablet-bold mt4 mb3 is-black"
                        >
                          {{ item.title }}
                        </h3>
                      </a>
                      <div
                        v-if="item.text"
                        class="f15px f18px-ns is-tablet-regular mb3 lh-copy"
                        v-html="marked(item.text)"
                      ></div>
                      <p
                        v-else
                        class="f15px f18px-ns is-tablet-regular mb3 lh-copy"
                      >
                        {{ item.text }}
                      </p>
                      <a
                        class="f15px f18px-ns is-tablet-regular ttu is-red link"
                        :title="item.cta.link_title"
                        :href="item.cta.link"
                        >{{ item.cta.text }}</a
                      >
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>

          <!-- Neighborhood M -->
          <div
            class="relative bg-beige z-content"
            v-if="isWindowWidthMobile == true"
          >
            <div class="relative container-fluid">
              <h3 class="f98px-ns f39px is-blenny is-navy ttu pt4">
                {{ page.the_neighborhood_section.title }}
              </h3>
            </div>
            <section
              class="relative center pt3 pb4 s-black"
              :id="page.the_neighborhood_section.slug"
            >
              <swiper
                :options="swiperOptions"
                ref="mySwiper2"
                class="container-fluid-important"
              >
                <swiper-slide
                  v-for="(item, index) in page.the_neighborhood_section
                    .neighborhoods"
                  :key="'neighborhood-items-m-' + index"
                >
                  <div class="relative">
                    <div class="db w-100">
                      <a
                        v-if="item.cta"
                        class="image-zoom2"
                        :title="item.cta.link_title"
                        :href="item.cta.link"
                      >
                        <div
                          class="relative aspect-ratio--1x1"
                          :style="{
                            background: 'url(' + item.image.src_image + ')'
                          }"
                        ></div>
                        <h3
                          class="f23px f38px-ns is-navy is-tablet-bold mt4 mb3 is-black"
                        >
                          {{ item.title }}
                        </h3>
                      </a>
                      <p class="f15px f18px-ns is-tablet-regular mb3 lh-copy">
                        {{ item.text }}
                      </p>
                      <a
                        v-if="item.cta && item.cta.is_published"
                        class="f15px f18px-ns is-tablet-regular ttu is-red link"
                        :title="item.cta.link_title"
                        :href="item.cta.link"
                        >{{ item.cta.text }}</a
                      >
                    </div>
                  </div>
                </swiper-slide>
              </swiper>
            </section>
          </div>

          <!-- Neighborhood DT -->
          <div
            class="relative bg-beige z-content"
            v-if="isWindowWidthMobile == false"
          >
            <div class="relative container-fluid">
              <section
                class="relative center mw8-5 pb4 pb5-ns is-black"
                :id="page.the_neighborhood_section.slug"
              >
                <div class="row">
                  <div class="col-xs-12">
                    <h3 class="f98px-ns f39px is-blenny is-navy ttu mb4">
                      {{ page.the_neighborhood_section.title }}
                    </h3>
                  </div>
                  <div
                    class="col-xs-12 col-sm-4 pb4 ph3"
                    v-for="(item, index) in page.the_neighborhood_section
                      .neighborhoods"
                    :key="'neighborhood-item-' + index"
                  >
                    <div class="w-100">
                      <a
                        class="image-zoom2"
                        :title="item.cta.link_title"
                        :href="item.cta.link"
                      >
                        <div
                          class="relative aspect-ratio--1x1"
                          :style="{
                            background: 'url(' + item.image.src_image + ')'
                          }"
                        ></div>
                        <h3
                          class="f23px f38px-ns is-navy is-tablet-bold mt4 mb3 is-black"
                        >
                          {{ item.title }}
                        </h3>
                      </a>
                      <div
                        class="f15px f18px-ns is-tablet-regular mb3 lh-copy"
                        v-html="item.text"
                      ></div>
                      <a
                        v-if="item.cta && item.cta.is_published"
                        class="f15px f18px-ns is-tablet-regular ttu is-red"
                        :title="item.cta.link_title"
                        :href="item.cta.link"
                        >{{ item.cta.text }}</a
                      >
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </template>
  </page-template>
</template>

<script>
import PageTemplate from "./page-template.vue";
import Accordion from "./accordion.vue";
import fixedbg from "./fixedbg.vue";
import FaqAnswerDropdown from "./faq-answer-dropdown.vue";
export default {
  components: {
    PageTemplate,
    Accordion,
    fixedbg
  },
  props: ["id", "pageMarkdownFileName"],
  metaInfo() {
    return {
      title: this.page.seo_title,
      titleTemplate: titleChunk => {
        return titleChunk
          ? `${titleChunk} | ` + this.$site_seo_title_suffix
          : this.$site_seo_title_suffix;
      },
      meta: [
        {
          vmid: "description",
          name: "description",
          content: this.page.seo_description
        }
      ]
    };
  },
  data() {
    return {
      appIsLoaded: true,
      logoIsLoaded: true,
      window: {
        width: 0,
        height: 0
      },
      isWindowWidthMobile: null,
      desktopActive: 0,
      mobileActive: -1,
      //bgOpaciy: 0,
      //bgScrollStart: this.$bgScrollStart,
      scrollPos: 0,
      bgIsAbsolute: false,
      mobileFaqAnswerExpanded: false,
      swiperOptions: {
        autoplay: {
          delay: 7000
        },
        speed: 800,
        autoplayDisableOnInteraction: false,
        // loop: true,
        initialSlide: 0,
        //pagination: '.swiper-pagination',
        paginationClickable: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: false
        },
        keyboardControl: true,
        initialSlide: 0,
        spaceBetween: 15,
        freeMode: false,
        slidesPerView: 1.3
      }
    };
  },
  computed: {
    page: function() {
      var pageData = this.$store.getters.filterPagesByName(
        this.pageMarkdownFileName
      );
      //console.log(pageData[0]);
      return pageData[0];
    },
    mobileFAQTopicElMinHeight: function() {
      return this.page.faq_section.faq_topics.length * 70;
    },
    swiper() {
      if (this.$refs.mySwiper) return this.$refs.mySwiper.swiper;
    },
    swiper2() {
      if (this.$refs.mySwiper2) return this.$refs.mySwiper2.swiper;
    }
  },
  updated() {
    //console.log('updated - ', this.mobileActive)
  },
  methods: {
    mobileMinHeight() {
      this.window.width = window.innerWidth;
      if (this.mobileActive > -1) {
        return this.mobileFAQTopicElMinHeight + 70 + "px";
      } else {
        return this.mobileFAQTopicElMinHeight + "px";
      }
    },
    scrollMeTo(refName) {
      var el = this.$refs[refName][0];
      var top = window.pageYOffset + el.getBoundingClientRect().top - 70;
      window.scrollTo(0, top);
    },
    mobileDesktop() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      if (this.window.width < 768) this.isWindowWidthMobile = true;
      else {
        this.isWindowWidthMobile = false;
        this.mobileActive = -1;
      }
      if (this.swiper) this.swiper.update();
      if (this.swiper2) this.swiper2.update();
    },
    sizing: function() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      if (this.window.width < 768) this.isWindowWidthMobile = true;
      else {
        this.isWindowWidthMobile = false;
        this.mobileActive = -1;
      }
      this.scrollBg();
      if (this.swiper) this.swiper.update();
    },
    bgIsAbsoluteMethod() {
      if (window.scrollY > this.$refs.participateSection.offsetTop) {
        this.bgIsAbsolute = true;
      } else {
        this.bgIsAbsolute = false;
      }
    }
  },
  created() {
    this.window.width = window.innerWidth;
    this.window.height = window.innerHeight;
    if (this.window.width < 768) this.isWindowWidthMobile = true;
    else this.isWindowWidthMobile = false;
    window.addEventListener("resize", this.mobileDesktop);
    window.addEventListener("load", this.mobileDesktop);
    //window.addEventListener('scroll', this.scrollBg);
    window.addEventListener("load", this.bgIsAbsoluteMethod);
    window.addEventListener("scroll", this.bgIsAbsoluteMethod);
  },
  destroyed() {
    window.removeEventListener("resize", this.mobileDesktop);
    window.removeEventListener("load", this.mobileDesktop);
    //window.removeEventListener('scroll', this.scrollBg);
    window.removeEventListener("load", this.bgIsAbsoluteMethod);
    window.removeEventListener("scroll", this.bgIsAbsoluteMethod);
  },
  beforeMount() {
    //
  },
  mounted() {
    /* Route path updates based on initial link */
    if (this.isWindowWidthMobile) {
      //console.log('windowWidthMobile - ', this.$route.path, this.mobileActive);
      if (
        this.$route.path === "/info/tickets-and-wristbands/" ||
        this.$route.path === "/info/tickets-and-wristbands"
      ) {
        this.mobileActive = 1;
      } else if (
        this.$route.path === "/info/venue/" ||
        this.$route.path === "/info/venue"
      ) {
        this.mobileActive = 2;
      } else if (
        this.$route.path === "/info/travel-and-transportation/" ||
        this.$route.path === "/info/travel-and-transportation"
      ) {
        this.mobileActive = 3;
      } else if (
        this.$route.path === "/info/cannabis/" ||
        this.$route.path === "/info/cannabis"
      ) {
        this.mobileActive = 4;
      } else if (
        this.$route.path === "/info/get-involved/" ||
        this.$route.path === "/info/get-involved"
      ) {
        this.mobileActive = 5;
      } else if (
        this.$route.path === "/info/safety/" ||
        this.$route.path === "/info/safety"
      ) {
        this.mobileActive = 6;
      } else {
        this.mobileActive = -1;
      }
    } else {
      //console.log('this.desktopActive', this.desktopActive);
      if (
        this.$route.path === "/info/tickets-and-wristbands/" ||
        this.$route.path === "/info/tickets-and-wristbands"
      ) {
        this.desktopActive = 1;
      } else if (
        this.$route.path === "/info/venue/" ||
        this.$route.path === "/info/venue"
      ) {
        this.desktopActive = 2;
      } else if (
        this.$route.path === "/info/travel-and-transportation/" ||
        this.$route.path === "/info/travel-and-transportation"
      ) {
        this.desktopActive = 3;
      } else if (
        this.$route.path === "/info/cannabis/" ||
        this.$route.path === "/info/cannabis"
      ) {
        this.desktopActive = 4;
      } else if (
        this.$route.path === "/info/get-involved/" ||
        this.$route.path === "/info/get-involved"
      ) {
        this.desktopActive = 5;
      } else if (
        this.$route.path === "/info/safety/" ||
        this.$route.path === "/info/safety"
      ) {
        this.desktopActive = 6;
      } else {
        this.desktopActive = 0;
      }
    }

    this.$nextTick(() => {
      //
    });
  },
  beforeDestroy() {
    //
  }
};
</script>
